import 'dayjs/locale/en-gb';
import 'dayjs/plugin/relativeTime';
import relativeTime from 'dayjs/plugin/relativeTime';
import dayjs from 'dayjs';
dayjs.locale('en-gb');
dayjs.extend(relativeTime);
export var dayts = dayjs;
export var monthList = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
export var monthShortList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export var lastMonths = function (currentMonth, count) {
    var list = [];
    var length = monthList.length;
    for (var index = currentMonth; index >= 0 && currentMonth < length && list.length < count && count <= length; index--) {
        list.push(monthList[index]);
        if (index === 0)
            index = 12;
    }
    return list;
};
//# sourceMappingURL=dayts.js.map